import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, NavigationEnd, NavigationStart } from '@angular/router';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {FileUploader} from 'ng2-file-upload';
import 'rxjs/add/operator/switchMap';
import {LocalStorageService} from 'angular-2-local-storage';
import {ApiService} from '../../services/api.service';
import {environment} from '../../../environments/environment';
import {LoginService} from '../../services/login.service';
import {NotificationsService} from 'angular2-notifications';
import {TabsetComponent} from 'ngx-bootstrap';
import {UtilsService} from '../../services/utils.service';
import {ModalHelper} from '../../services/modalService/modal.helper';
import {GoogleAnalyticsService} from '../../services/google-analytics-service';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../helper/backend-translate.service';
import { HelperService } from '../../helper/helper.service';
import {ReportsService} from '../reports.service';
import {Cookie} from 'ng2-cookies/ng2-cookies';
import { Observable } from 'rxjs/Observable';
import _ from 'lodash';
import {ModalService} from '../../services/modalService/modal.service';
import {LoseReportModalComponent} from '../../custom-modals/lose-report-modal.component';
import {CanComponentDeactivate} from '../../guards/deactivate.guard';

@Component({
  selector: 'app-reports',
  templateUrl: './myreports.component.html',
  styleUrls: ['./myreports.component.css']
  
})
export class MyReportsComponent implements OnInit, CanComponentDeactivate  {
  @ViewChild('reports')
  staticTabs: TabsetComponent;

  hasBaseDropZoneOver = false;
  uploader: FileUploader = new FileUploader({
    url: `${environment.AmazonS3}`
  });
  
  modalRef: any;
  nextRoute = '';
  
  public progress: number = -1;
  public operation = '';
  public fileName = '';
  public lastFileName: any;
  public fileSize = 0;
  public summary: any;
  ws;
  ruid: any;
  isLicense = false;
  isAlreadyOpened = false;
  isLoggedIn = false;
  isParsed: any = false;
  isLastReportView: any = false;
  currentUser: any;
  vendorSpecific: any;
  appLanguage = window.localStorage.getItem('lang');
  s3MaxUploadSize: string;
  initialChartPage: boolean;

  public loadHistory = false;
  public noRuid = false;
  public recentUpload = false;

  public reportsTableValues: Array<string> = [];
  perpage = 10;
  TotalPages = 0;
  columns = [
    {name: 'fileName', sort: 'asc', isCurrent: false},
    {name: 'vendors', sort: 'asc', isCurrent: false},
    {name: 'fileSize', sort: 'asc', isCurrent: false},
    {name: 'uploadTime', sort: 'desc', isCurrent: true},
    {name: 'reportedPeriod', sort: 'asc', isCurrent: false}];
  currentPageIndex = 0;
  searchString = '';
  lastAppliedSearch = '';
  totalItems = 0;
  pages: number[] = [];
  selectedFile: any;
  environment: any = environment;
  lang = localStorage.getItem('lang');
  get currentColumn() {
    return _.find(this.columns, {isCurrent: true}) || {};
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private ga: GoogleAnalyticsService,
    private localStorageService: LocalStorageService,
    private loginService: LoginService,
    private notifications: NotificationsService,
    private utilsService: UtilsService,
    private modalHelper: ModalHelper,
    private modalService: ModalService,
    private translate: TranslateService,
    private backendTranslate: BackendTranslateService,
    private helperService: HelperService,
    private reportService: ReportsService) {
      // Url contains query params with ruid means it's may be refreshing page.
      // We need to set last report view to true if Last report viewed page is refreshed.
	  this.route.queryParams.subscribe((value) => {
    	this.loginService.isLoggedIn()
          .subscribe((currentUser) => {
              this.currentUser = currentUser;
              this.isLoggedIn = this.currentUser.isLoggedIn;
              if(!this.isLoggedIn) {
            	  this.localStorageService.set('isAnonymousReport', true);
              }
              this.s3MaxUploadSize = this.apiService.getS3SuitableMaxUploadSize(this.currentUser);
        	  if (value.ruid) {
                  this.isLastReportView = true;
                  this.lastFileName = this.localStorageService.get('lastFileName');
              } else {
                  this.noRuid = true;
              }
        } , (err) => { 
        	this.localStorageService.set('isAnonymousReport', true);
        	if (value.ruid) {
                this.isLastReportView = true;
                this.lastFileName = this.localStorageService.get('lastFileName');
            } else {
                this.noRuid = true;
            }
        });
      });
	  
	  this.router.events.filter(e => e instanceof NavigationEnd).subscribe((val: NavigationEnd) => {
        if (val.url.includes('session-length')) {
          this.initialChartPage = true;
        }
      });
	  
	  this.router.events.filter(e => e instanceof NavigationStart).subscribe((val: NavigationStart) => {
	    this.nextRoute = val.url;
	  });
  }

  ngOnInit() {
    // this.doNotLoadHistory = true;
	this.recentUpload = true;
	this.localStorageService.set('isAccessLogInMenuClose', false);
	this.loginService.isLoggedIn()
      .subscribe((currentUser) => {
          this.currentUser = currentUser;
          this.isLoggedIn = this.currentUser.isLoggedIn;
          this.s3MaxUploadSize = this.apiService.getS3SuitableMaxUploadSize(this.currentUser);
          if (this.localStorageService.get('openLastViewed')) {
              this.isLastReportView = true;
          }
          this.helperService.helperService$.subscribe(val => {
              if (!val.doNotLoadReports) {
                this.loadHistory = true;
              }
            });

            if (!this.isLastReportView || this.noRuid) {
              this.helperService.loadHistoryReports();
              this.getReportsHistory(this.currentPageIndex, 'uploadTime', 'desc', '');
            }

            
            this.isAlreadyOpened = false;
            this.route.queryParams.subscribe(params => {
              const ruid = params.ruid;
              if(params.fileName){
            	  this.lastFileName = params.fileName;
                  this.localStorageService.set('lastFileName', this.lastFileName);
              }
              this.openReport(ruid);
            });
    });
  }
  

  canExit(): Observable<boolean> {
	if((this.currentUser && this.isLoggedIn)) {
		this.localStorageService.set('isAccessLogInMenu', false);
		this.localStorageService.set('isAccessLogInMenuClose', false);
		return Observable.of(true);
	} else if(this.localStorageService.get('isAccessLogInMenuClose')) {
		this.localStorageService.set('isAccessLogInMenuClose', false);
		return Observable.of(true);
	} else if(this.localStorageService.get('isAccessLogInMenu')) {
		this.localStorageService.set('isAccessLogInMenu', false);
		return Observable.of(false);
	} else {
		const openLeaveDialogVar = this.openLeaveDialog();
	    return openLeaveDialogVar;
	}
  }
  
  openLeaveDialog() : Observable<boolean> {
	    return this.modalService.open(LoseReportModalComponent, {
	      	title: this.translate.instant('common.info'),
	      	data: { message: this.translate.instant('common.info') }
	    });
  }

  openReport(ruid) {
    // console.log('open report: ' + ruid);
    this.isParsed = false;
    if ((ruid && this.localStorageService.get('lastRuid') == null) || (ruid && this.localStorageService.get('lastRuid') !=null)) {
        this.isParsed = this.localStorageService.get('isParsed');
        // console.log('Is Parsed: ' + this.isParsed);
        // this.localStorageService.remove('isParsed');
        // console.log('Ruid: ' + ruid);
        this.apiService.getSummary(ruid)
          .subscribe((res) => {
              this.ruid = ruid;
              this.isLastReportView = true;
              this.localStorageService.set('openLastViewed', true);
              this.localStorageService.set('lastRuid', ruid);

              this.apiService.getVendorSpecificReports(ruid)
                  .subscribe((vendors) => {

                      if (vendors) {
                          this.vendorSpecific = vendors;
                      }

                      if (this.staticTabs.tabs[0].id === 'myreports') {
                          this.staticTabs.tabs[1].active = true;
                      } else {
                    	  if (this.staticTabs.tabs[0].id === 'reportNoLoggin') {
                    		  this.staticTabs.tabs[1].active = true;
                    	  } else {
                    		  this.staticTabs.tabs[0].active = true;
                    	  }
                      }
                      this.summary = res;
                      this.summary.formatHTMLDescription = this.utilsService.decodeHtml(this.summary.formatHTMLDescription);
                      if(!this.isAlreadyOpened) {
      					  this.isAlreadyOpened = true;
	                      if (this.summary.linesParsed < this.summary.linesTotal) {
	                        let linesParsedStr = `${environment.parseLineLimitLight}`;
							if(this.currentUser && this.currentUser.pk && !this.currentUser.paid && !this.currentUser.premium) {
								linesParsedStr = `${environment.parseLineLimitBasic}`;
							}
							this.modalHelper.openFilesLimitUploadModal({
								title: this.translate.instant('reports.reportContain.title', {p0: linesParsedStr}),
								message: this.translate.instant('reports.reportContain.message'),
								showGoPremiumButton: true
							}, null);
	                      }
	                  }
                      this.isLicense = res.isLicense;
                      this.localStorageService.remove('isParsed');
                      if (res.isLicense) {
                          this.router.navigate(['reports/myreports/features'], {queryParams: {ruid: ruid}});
                      } else {
                          this.router.navigate(['reports/myreports/session-length'], {queryParams: {ruid: ruid}});
                      }
                  }, (error) => {
                      this.localStorageService.remove('isParsed');
                      this.notifications.error(this.translate.instant('common.error'),
                          this.apiService.getMessageFromError(error, this.translate.instant('reports.failedVendor') + ruid));
                  });
          }, (error) => {
              this.ruid = undefined;
              this.localStorageService.remove('isParsed');
              // this.staticTabs.tabs[1].active = true;
              this.router.navigate(['reports/myreports']);
              this.notifications.error(this.translate.instant('common.error'),
                  this.apiService.getMessageFromError(error, this.translate.instant('reports.failedReport') + ruid));
          });
      } else {
    	this.tabSelected('reports');
        // console.log(this.staticTabs);
        if (this.staticTabs.tabs[0].id === 'myreports') {
             this.staticTabs.tabs[0].active = true;
        } else {
            this.staticTabs.tabs[1].active = true;
        }
    }
  }

  public getFormatHTML(): string {
      return this.utilsService.decodeHtml(this.backendTranslate.translateMessage(this.summary.formatHTMLDescription));
  }

  fileOverBase(fileOver: any) {
    this.hasBaseDropZoneOver = fileOver;
  }

  upload(file) {
    this.ga.emitEvent('Reports Upload', 'Upload File', 'Upload');
    
    let s3MaxUploadSize = this.apiService.getS3SuitableMaxUploadSize(this.currentUser);
		let awsError = this.translate.instant('common.awsErrorFileSizeLimit') + s3MaxUploadSize;
    if(this.currentUser.isLoggedIn && this.currentUser.paid && (file[0].size > environment.advancedPlanUploadLimit)) {
      this.modalHelper.openGeneric(
        {
        title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
        message: awsError,
        order : 0,
              addFooterBtn : true,
              isCancel: true,
              cancelText: this.translate.instant('common.close'),
                centered: true
        },
        null
      );
      return;
    } else if(this.currentUser.isLoggedIn && !this.currentUser.paid && (file[0].size > environment.basicPlanUploadLimit)) {
      this.modalHelper.openFilesLimitUploadModal(
        {
          title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
          message: awsError
        },
        null
      );
      return;
    } else if(!this.currentUser.isLoggedIn && !this.currentUser.paid && (file[0].size > environment.demoPlanUploadLimit)) {
      this.modalHelper.openFilesLimitUploadModal(
        {
          title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
          message: awsError
        },
        null
      );
      return;
    }

    const that = this;
    this.apiService.generateUid(file[0].name,'')
      .subscribe(generateUidData => {
        const ruid = this.apiService.uniqueName(generateUidData.ruid, file[0].name);

        this.fileName = file[0].name;
        this.lastFileName = this.fileName;
        this.localStorageService.set('lastFileName', this.lastFileName);
        this.fileSize = Math.ceil(file[0].size / 1024);
        that.progress = 0;
        that.operation = that.translate.instant('reports.connecting');
        this.apiService.upload(generateUidData, ruid, file[0])
          .subscribe(event => {
              if (event.type === HttpEventType.UploadProgress) {
                const percentDone = Math.round(100 * event.loaded / event.total);
                that.operation = that.translate.instant('reports.uploading');
                that.progress = percentDone;
              } else if (event instanceof HttpResponse) {
                that.progress = 0;
                that.operation = that.translate.instant('reports.pending');
                that.apiService.parseData(file[0].name)
                  .subscribe(data => {
                    that.ws = new WebSocket(environment.webSocket);
                    that.ws.onmessage = function (wsEvent) {
                      const d = JSON.parse(wsEvent.data);

                      if (d.type == 'CONTEXT_ID') {
                      } else if (d.type == 'UID') {
                        that.ruid = d.value;
                      } else if (d.type == 'CLOSE') {
                        that.ws.close();
                        that.ws = null;
                        if (d.value == 'true') {
                          that.operation = that.translate.instant('reports.completed');
                          that.progress = 0;
                          that.ruid = ruid;
                          that.getReportDetails();
                        } else {
                          that.operation = that.translate.instant('reports.completedErrors');
                        }
                      } else if (d.type == 'PROGRESS') {
                        that.progress = parseInt(d.value, 10);
                        that.operation = that.translate.instant('apiMessages.fileParserProgressMsg1') + ' ' + that.progress + '%';
                      } else if (d.type == 'INFO') {
                        that.progress = 0;
                        that.operation = that.backendTranslate.translateMessage(d.value);
                      } else if (d.type == 'WARN' || d.type == 'ERROR') {
                        that.ruid = undefined;
                        that.progress = 0;
                        that.modalHelper.openGeneric({ message: that.backendTranslate.translateMessage(d.value)}, null);
                        if (that.staticTabs.tabs[0].id === 'last') {
                          that.staticTabs.tabs[1].active = true;
                        } else {
                          that.staticTabs.tabs[0].active = true;
                        }
                      }
                    };

                    that.ws.onopen = function (wsEvent) {
                      this.send(JSON.stringify({contextId: data.contextId}));
                      that.apiService.parseDataPost(ruid, data.fileName, data.contextId)
                        .subscribe((parseData) => {
                        });
                    };

                    that.ws.onclose = function (wsEvent) {
                      that.progress = -1;
                    };
                  }, (err) => {
                      that.notifications.error(that.apiService.getMessageFromError(err, this.translate.instant('reports.uploadFile')));
                  });
              }
            }
            , (err) => {
              that.progress = -1;
              const awsError = that.apiService.getAWSMessage(err, that.currentUser);
              let errorMessage = '';
              if (awsError) {
                  if(that.currentUser.paid) {
	              	this.modalHelper.openGeneric(
							  {
								title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
								message: awsError,
								order : 0,
				            	addFooterBtn : true,
				            	isCancel: true,
				            	cancelText: this.translate.instant('common.close'),
				                centered: true
							  },
							  null
				    );
	              } else {
	              	this.modalHelper.openFilesLimitUploadModal(
							  {
								title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
								message: awsError
							  },
							  null
				    );
	              }
              } else {
                  errorMessage = that.apiService.getMessageFromError(err, this.translate.instant('reports.error', {error: err.statusText}));
                  that.notifications.error(errorMessage);
              }
            });
      }, (error) => {
      	  let isMaxNumberOfFileUploadsError = false;
          if (error && error._body) {
	          try {
	              let jsonError = JSON.parse(error._body).message;
	              if(jsonError.startsWith("fileParserUidError3")){
	              		isMaxNumberOfFileUploadsError = true;
	              		this.modalHelper.openFilesLimitUploadModal({
	              				  title: this.translate.instant('reports.maxNumberOfFileUploads.title'),
	                              message: this.translate.instant('reports.maxNumberOfFileUploads.message'),
	                              showGoPremiumButton: true
	                    }, null);
	              }
	          } catch (exc) {
	          	  isMaxNumberOfFileUploadsError = false;
	          	  console.log(exc);
	          }
          }

          if(!isMaxNumberOfFileUploadsError) {
          	that.notifications.error(that.apiService.getMessageFromError(error, this.translate.instant('reports.uploadFile')));
          }
      });
  }

  getReportDetails() {
    if (this.ruid) {
      this.localStorageService.set('isParsed', true);
      this.localStorageService.set('openLastViewed', true);
      this.router.navigate(['reports'], {queryParams: {ruid: this.ruid}});
      this.recentUpload = true;
    }
  }

  routeVendor(data) {
	  this.router.navigate(['reports/myreports/vendor-specific'], {queryParams: {vendor: data.name, ruid: this.ruid}});
  }
  
  sendGaEvent(ea) {
  	if(this.isLoggedIn) {
  		this.ga.emitEvent('Reports', ea, 'Click');
  	} else {
  		this.ga.emitEvent('Reports Not Registered', ea, 'Click');
  	}
  }

  fileUpload(event) {
    if (event.target.files && event.target.files[0]) {
      this.upload(event.target.files);
    }
  }

  resetFileUpload(event) {
    event.target.value = null;
  }

  tabSelected(tabName: string) {
      if (tabName === 'reports') {
          if (this.recentUpload) {
        	this.getReportsHistory(this.currentPageIndex, 'uploadTime', 'desc', '');
            this.recentUpload = false;
          }
          this.router.navigate(['reports/myreports']);
          this.helperService.loadHistoryReports();
      } else {
          const openLastViewed = this.localStorageService.get('openLastViewed');
          if (openLastViewed === true) {
              this.ruid = this.localStorageService.get('lastRuid');
              this.lastFileName = this.localStorageService.get('lastFileName');
          }
          // if (!this.localStorageService.get('isParsed')) {
            this.openReport(this.ruid);
          // }
      }
  }
  
  changeSelectedFile(report) {
    if (this.selectedFile === report) {
      this.selectedFile = undefined;
    } else {
      this.selectedFile = report;
    }
  }

  getReportsHistory(page, columnName, Sort, search) {
    this.ga.emitEvent('Reports Actions', 'View Report', 'Click');
    
    let date = new Date();
    let userTimeZoneOffset = date.getTimezoneOffset();
    
    this.reportService.getReportHistory(page, this.perpage, columnName, Sort, search, userTimeZoneOffset)
      .subscribe((res) => {
        this.reportsTableValues = res.json();
        this.totalItems = parseInt(res.headers.get('X-Total-Count'), 10);
        this.TotalPages = Math.ceil(this.totalItems / this.perpage);
        this.pages = [];
        for (let i = 0; i < this.TotalPages; i++) {
          this.pages.push(i);
        }
      }, (error) => {
          this.notifications.error(this.translate.instant('common.error'),
          this.apiService.getMessageFromError(error, this.translate.instant('reports.history.failedRep')));
      });
  }

  searchData() {
    this.ga.emitEvent('Reports Actions', 'Search Report', 'Click');
    const current = this.currentColumn;
    if (this.searchString) {
      this.lastAppliedSearch = this.searchString;
      this.getReportsHistory(this.currentPageIndex, current.name, current.sort, this.lastAppliedSearch);
    } else {
      this.getReportsHistory(this.currentPageIndex, current.name, current.sort, '');
    }
  }

  resetSort() {
    _.each(this.columns, function (column) {
      column.isCurrent = false;
    });
  }

  sortCols(column) {
    let obj = _.find(this.columns, {name: column});
    this.resetSort();
    obj.isCurrent = true;

    if (obj.sort === 'asc') {
      obj.sort = 'desc';
    } else {
      obj.sort = 'asc';
    }
    this.getReportsHistory(this.currentPageIndex, obj.name, obj.sort, `${this.lastAppliedSearch != '' ? this.lastAppliedSearch : ''}`);
  }

  pageIndexChange(pageIndex) {
    this.currentPageIndex = pageIndex - 1;
    const currentColumn = this.currentColumn;
    this.getReportsHistory(this.currentPageIndex, currentColumn.name, currentColumn.sort,
        `${this.lastAppliedSearch != '' ? this.lastAppliedSearch : ''}`);
    return this.currentPageIndex + 1;
  }

  downloadPDF() {
    this.ga.emitEvent('Reports Actions', 'Download PDF', 'Click');
    if (this.selectedFile) {
      const jsessionid = Cookie.get('JSESSIONID');
      window.open(environment.baseURL + `/api/report/pdf;jsessionid=${jsessionid}?ruid=` + encodeURIComponent(this.selectedFile.ruid));
    }
  }

  viewReport(file) {
    this.ga.emitEvent('Reports Actions', 'View Report', 'Click');
    if (!file) {
        file = this.selectedFile;
    }
    if (file) {
      this.localStorageService.remove('isParsed');
      this.localStorageService.set('openLastViewed', true);
      this.router.navigate(['/reports/myreports'], {queryParams: {ruid: file.ruid, fileName: file.fileName}});
    }
  }

  deleteReport(file) {
    this.ga.emitEvent('Reports Actions', 'Delete Report', 'Click');
    if (!file) {
        file = this.selectedFile;
    }
    if (file) {
      this.reportService.deleteReport(encodeURIComponent(file.ruid)).subscribe(
        res => {
          this.getReportsHistory(this.currentPageIndex, 'uploadTime', 'desc', '');
          this.selectedFile = {};
        },
        err => {
          console.log('Failed delete report ', err);
        });
    }
  }

  clearSearch(e) {
    e.preventDefault();
    this.lastAppliedSearch = '';
    this.searchString = '';
    this.getReportsHistory(this.currentPageIndex, '', '', this.lastAppliedSearch);
  }

  clearSort(e) {
    e.preventDefault();
    this.resetSort();
    this.getReportsHistory(this.currentPageIndex, '', '', this.lastAppliedSearch);
  }
  
  commonFunction() {
  }
  
  
  
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/myreports.component.ts